import { render, staticRenderFns } from "./galleryCategories.vue?vue&type=template&id=c3ca94ce&"
import script from "./galleryCategories.vue?vue&type=script&lang=js&"
export * from "./galleryCategories.vue?vue&type=script&lang=js&"
import style0 from "./galleryCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports